// To be kept in sync with https://git.hubteam.com/HubSpot/IdentityBase/blob/7cd0a009f1b42358acc71233453184014b5412d7/src/main/protobuf/contacts.proto#L279
// (link is to commit as of 12/05/2023, check file at latest master for updates)

export const PropertyDataSensitivity = {
  NONE: 'none',
  STANDARD: 'standard',
  HIGH: 'high'
};